<template>
  <div id="page">
    <sub-menu id="section-submenu" nohide="true"></sub-menu>
    <div class="block-wrapper">
      <div class="content sans">
        <div
          v-for="(block, index) in blocks"
          class="block-wrapper"
          :key="index"
        >
          <h3 class="block-heading mb2" v-if="block.block_heading">
            {{ block.block_heading }}
          </h3>
          <div
            v-if="block.block_content && block.block_content.columns === '1'"
            class="block-content"
            v-html="block.block_content.column_1"
          ></div>
          <div
            v-else-if="block.block_content"
            class="block-content flex two-col"
          >
            <div
              v-html="block.block_content.column_1"
              class="block-column col-6"
            ></div>
            <div
              v-html="block.block_content.column_2"
              class="block-column col-6"
            ></div>
          </div>
        </div>

        <div class="block-wrapper">
          <h3 class="block-heading mb2" v-if="!blocks.length">Newsletter</h3>
          <div class="block-content">
            <div class="signup-form">
              <iframe
                src="https://forensis.substack.com/embed"
                width="480"
                height="320"
                title="Subscribe to the Forensis newsletter"
                frameborder="0"
                scrolling="no"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SubMenu from "@/components/SubMenu";

export default {
  name: "Newsletter",

  metaInfo() {
    const title = "Newsletter";
    return {
      title: title,
      meta: [
        {
          name: "og:title",
          content: `${process.env.VUE_APP_TITLE} → ${title}`,
        },
        {
          name: "twitter:title",
          content: `${process.env.VUE_APP_TITLE} → ${title}`,
        },
        { name: "og:image", content: "/fa-share-lg.png" },
        { name: "twitter:image", content: "/fa-share-lg.png" },
        {
          name: "og:url",
          content: `${window.location.origin}/${this.$route.fullPath}`,
        },
        { name: "og:type", content: "website" },
        { name: "og:description", content: this.siteDescription() },
        { name: "twitter:description", content: this.siteDescription() },
      ],
    };
  },

  components: {
    SubMenu,
  },

  computed: {
    ...mapState(["pages"]),
    // Optional intro copy, if a 'newsletter' page is added in the CMS
    blocks() {
      const page = this.pages["newsletter"];
      return (page && page.acf && page.acf.description) || [];
    },
  },

  methods: {
    ...mapActions(["getPage"]),
  },

  created: function () {
    this.getPage("newsletter");
  },
};
</script>

<style lang="css" scoped>
#page {
  .block-wrapper {
    margin-bottom: 6em;
  }
}
.signup-form {
  display: flex;
  justify-content: center;
  width: 100%;

  /* .block-wrapper stretches iframes to 100%, keep the embed at its own size */
  iframe {
    width: 480px;
    max-width: 100%;
    height: 320px;
    background: white;
    border: 1px solid #eee;
  }
}
</style>
